import { Component, Input } from '@angular/core';
import type { State } from '@core/jss-routing';
import { InnogyComponentRendering } from '@core/jss-models';
import { Store } from '@ngrx/store';
import { map, withLatestFrom } from 'rxjs/operators';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { AsyncPipe } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import {
  getBlogNodeNavigationMain,
  hasSubcategories,
  hasArticles,
} from '../+state/blog.selector';
import { CategoryFilterComponent } from '../category-filter/category-filter.component';
import { SubcategoryFilterComponent } from '../subcategory-filter/subcategory-filter.component';

@Component({
  selector: 'wl-category-navigation',
  templateUrl: './category-navigation.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    CategoryFilterComponent,
    SubcategoryFilterComponent,
    JssModule,
    AutomationIdDirective,
    AsyncPipe,
  ],
})
export class CategoryNavigationComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;

  main$ = this.store$.pipe(getBlogNodeNavigationMain);
  hasSubcategoryFilter$ = this.store$.pipe(hasSubcategories);
  private readonly hasArticles$ = this.store$.pipe(hasArticles);
  hasSubcategoriesOrNoArticles$ = this.hasSubcategoryFilter$.pipe(
    withLatestFrom(this.hasArticles$),
    map(([hasSubCategories, hasArticle]) => !hasArticle || hasSubCategories)
  );

  constructor(private readonly store$: Store<State>) {}
}
